import React from 'react';
import { Link } from 'react-router-dom';
import { Home, RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="relative">
          {/* Animated Background Elements */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#FF6B9D]/10 rounded-full blur-3xl animate-pulse" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-[#FFB6C1]/20 rounded-full blur-2xl animate-pulse delay-700" />

          {/* 404 Text */}
          <h1 className="relative text-9xl font-black text-[#FF6B9D] drop-shadow-sm">
            404
          </h1>
        </div>

        <div className="space-y-4 relative">
          <h2 className="text-3xl font-bold text-gray-900">Oops! Lost in Space</h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            The page you're looking for seems to have drifted away.
            Don't worry, we can help you find your way back.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button
            asChild
            className="bg-[#FF6B9D] hover:bg-[#ff5a8c] text-white rounded-full px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
          >
            <Link to="/" className="flex items-center">
              <Home className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
          </Button>

          <Button
            variant="outline"
            onClick={() => window.location.reload()}
            className="border-[#FF6B9D] text-[#FF6B9D] hover:bg-pink-50 rounded-full px-8 py-6 text-lg"
          >
            <RefreshCw className="w-5 h-5 mr-2" />
            Try Again
          </Button>
        </div>

        <div className="pt-12">
          <div className="flex items-center justify-center space-x-2 text-gray-400 text-sm">
            <AlertCircle className="w-4 h-4" />
            <span>Connection status: Online</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
